import { Group, Text } from '@mantine/core';

export const MetricItem = ({ label, value }: { label: string; value: string | number }) => (
  <Group pb={8} justify="space-between">
    <Text size="sm">{label}:</Text>
    <Text size="sm">{value}</Text>
  </Group>
);
